// intersectionobserver polyfill
require('intersection-observer');

// svg polyfill for better use element support
require('svgxuse');

// track input methods for styling
require('what-input');

// automatically require all modules
require('./modules/_Slider.js');require('./modules/_activities.js');require('./modules/_animate.js');require('./modules/_block.js');require('./modules/_cards.js');require('./modules/_club101.js');require('./modules/_flextabs.js');require('./modules/_fundraiser.js');require('./modules/_header.js');require('./modules/_map.js');require('./modules/_minimodal.js');require('./modules/_slideshow.js');require('./modules/_widget.js');
